<template>
  <div class="flex items-center justify-center w-full" :class="$attrs.class">
    <div class="form-input p-0" :class="{ error: errors.length }">
      <label class="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-gray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600" @click="browse">
        <div class="flex flex-col items-center justify-center pt-5 pb-6" v-if="!imageSrc">
          <svg class="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
          </svg>
          <p class="mb-2 text-sm text-gray-500 dark:text-gray-400"><span class="font-semibold">Click para cargar</span> o arrastrar y soltar el archivo</p>
          <p class="text-xs text-gray-500 dark:text-gray-400">SVG, PNG, JPG or GIF (MAX. 800x400px)</p>
        </div>
        <img :src="imageSrc" v-else class="max-w-full max-h-full object-contain" alt="Imagen cargada">
      </label>
      <input :id="id" ref="file" type="file" class="hidden" :accept="accept" @change="change" />
      <button type="button" class="w-full px-4 py-2 text-white text-xs font-medium bg-gray-500 hover:bg-red-600 rounded-sm" @click="remove" v-if="imageSrc">Eliminar</button>
    </div>
    <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
  </div> 
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `file-input-${uuid()}`
      },
    },
    errors: {
      type: Array,
      default: () => [],
    },
    accept: String,
    label: String,
    modelValue: File,
  },
  emits: ['update:modelValue'],
  data() {
    return {
      imageSrc: ''
    }
  },
  watch: {
    modelValue(value) {
      if (!value) {
        this.$refs.file.value = ''
        this.imageSrc = ''
      }
    },
  },
  methods: {
    filesize(size) {
      var i = Math.floor(Math.log(size) / Math.log(1024))
      return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
    },
    browse() {
      this.$refs.file.click()
    },
    change(e) {
      const file = e.target.files[0]
      this.$emit('update:modelValue', file)
      // Mostrar la imagen cargada
      if (file) {
        const reader = new FileReader()
        reader.onload = (event) => {
          this.imageSrc = event.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    remove() {
      this.$emit('update:modelValue', null)
      this.imageSrc = ''
    },
  },
}
</script>
